import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  CircularProgress,
  Button,
} from '@mui/material';
import { BASE_URL } from '../config/Config';

const API_PATH = {
  terms: '/api/accounts/legal/terms/',
  privacy: '/api/accounts/legal/privacy/',
};

const TITLE = {
  terms: 'Terms of Service',
  privacy: 'Privacy Policy',
};

export default function LegalContentPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname === '/privacy' ? 'privacy' : 'terms';
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${BASE_URL}${API_PATH[path]}`, { method: 'GET' });
        const data = await res.json();
        if (cancelled) return;
        if (res.ok) {
          setContent(data.content ?? '');
        } else {
          setError(data.error || 'Failed to load content.');
        }
      } catch (e) {
        if (!cancelled) setError('Network error. Please try again.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [path]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="40vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Typography color="error">{error}</Typography>
        <Button onClick={() => navigate(-1)} sx={{ mt: 2 }}>Go back</Button>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        {TITLE[path]}
      </Typography>
      <Box
        component="pre"
        sx={{
          whiteSpace: 'pre-wrap',
          fontFamily: 'inherit',
          fontSize: '1rem',
          lineHeight: 1.6,
        }}
      >
        {content}
      </Box>
      <Button onClick={() => navigate(-1)} variant="outlined" sx={{ mt: 3 }}>
        Go back
      </Button>
    </Container>
  );
}
